import { useEffect, useState } from 'react';
import getUserLicenses from '../api/getUserLicenses';

export interface Subscription {
    id: number;
    teamId: number;
    name: string;
    logo: string;
    status: number;
    price: string;
    isTrial: boolean;
    isIap: boolean;
    isBundle: boolean;
    isForCoaching: boolean;
    isProgram: boolean;
    nextBillingDate: string;
}

export default function useMarketplaceSubscriptions() {
    const [loading, setLoading] = useState(true);
    const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
    const [error, setError] = useState<string | null>(null);

    const fetchSubscriptions = async () => {
        setLoading(true);
        setError(null);
        const response = await getUserLicenses();
        if (response?.status && response.status !== 200) {
            setError('Failed to load marketplace subscriptions. Please try again.');
        } else {
            setSubscriptions(response ?? []);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    const hasSubscriptions = subscriptions.length > 0;
    const clearError = () => setError(null);

    return {
        loading,
        subscriptions,
        error,
        hasSubscriptions,
        clearError,
        setError,
        fetchSubscriptions,
    };
}
